import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { ModuleProps } from "modules/modules/store/actionType";


export const TableColumns: ColumnDef<ModuleProps>[] = [
  // {
  //   id: "slNo",
  //   header: "Sl. No",
  //   cell: ({ row }) => row.index + 1,
  // },
  {
      accessorFn: (row) => row?.name,
      id: "name",
      cell: (info) => info.getValue(),
      header: () => <span>Name</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.menu,
      id: "menu",
      cell: (info) => info.getValue(),
      header: () => <span>Menu</span>,
      filterFn: "equalsString",
    },
  // {
  //   id: "action",
  //   cell: ({ row }) => {
  //     return (
  //     <div className="flex justify-center items-center gap-2">   
  //     </div>
  //   )},
  //   header: () => <span>Actions</span>,
  //   enableSorting: false,
  // },
];
